import { Component, Input } from '@angular/core';
import { gettingStartedFor } from '../../../data/platform/getting-started.data';

/** the install steps of one platform: one box per platform, however many products of it */
export interface StoreGuide {
  platform: string;
  platformName: string;
  platformLogo: string;
  steps: string[];
}

/**
 * "Getting started on <platform>", one always-open box per platform, under
 * the cart and the order page's rows (owner decision 2026-09-20: never per
 * row, three Sublime themes are one Sublime box, plain text, no toggle).
 * `guidesFor` builds the list from any rows that carry a platform.
 */
@Component( {
  selector: 'app-store-guides',
  templateUrl: './store-guides.component.html',
  styleUrls: [ './store-guides.component.scss' ],
} )
export class StoreGuidesComponent {

  @Input() guides: StoreGuide[] = [];

  /** one guide per platform in order of first appearance; platforms without steps are skipped */
  static guidesFor( rows: { platform: string; platformName: string; platformLogo: string }[] ): StoreGuide[] {
    const guides: StoreGuide[] = [];
    for ( const row of rows ) {
      if ( guides.some( g => g.platform === row.platform ) ) continue;
      const steps = gettingStartedFor( row.platform );
      if ( steps.length ) guides.push( { platform: row.platform, platformName: row.platformName, platformLogo: row.platformLogo, steps } );
    }
    return guides;
  }

  trackByPlatform( index: number, guide: StoreGuide ): string {
    return guide.platform;
  }
}
